<template>
  <div class="ml-2">
    
    <div class="py-2">
      <app-browse-contacts :folderFilter="folderId" v-model="selectedLinkContact" class="fill-height scrollable"  :multi-select="false">
        <template #activator>
          <app-contact-card
            v-if="value.value"
            :contact-id="value.value"
          />
          
          <v-btn class="mx-0" color="secondary" small>
            <v-icon left>link</v-icon>
            Select Contact
          </v-btn>
        </template>
        
        <template #actions="{selectedContacts, hideDialog}">
          <v-card-actions class="c-d-flex c-justify-end">
            <v-btn
                @click="() => hideDialog()"
                flat
            >
              Cancel
            </v-btn>
            <v-btn
                :disabled="!Array.isArray(selectedContacts) || !selectedContacts.length"
                color="secondary"
                @click="updateLinkedContact(selectedContacts, hideDialog)"
            >
              Select Contact
            </v-btn>
          </v-card-actions>
        </template>
      </app-browse-contacts>
    </div>
    
  </div>
</template>

<script>
import AppBrowseContacts from "@/contacts/AppBrowseContacts.vue";
import AppContactCard from "@/components/General/appContactCard.vue";

export default {
  components: {AppContactCard, AppBrowseContacts},
  props: {
    value: Object,
    readOnly: Boolean,
    folderId: Number,
  },
  data() {
    return {
      loading: false,
      loadingContactInfo: false,
      contactInfo: null,
      selectedLinkContact: null
    }
  },
  methods: {
    
    updateLinkedContact(selectedContacts, hideCb) {
      const contact = selectedContacts.shift()
      this.value.value = contact.id
      hideCb()
    },
  },
  computed: {
    name() {
      return this.data
    }
  },
}
</script>

<style scoped>

</style>
